import { Component } from '@angular/core';

@Component({
    selector: 'app-full-layout',
    templateUrl: './full-layout.component.html',
    styleUrl: './full-layout.component.scss',
    standalone: false
})
export class FullLayoutComponent {
    constructor() {}
}
